<template>
  <div class="artwork-card" @click="goToDetail()">
    <div class="header">
      <!--      <LikeButton :isLiked="artwork.isLiked" @buttonClick="handleLike()" />-->
      <!--      <div v-if="artwork.isOfferable" class="offer-avaiable">-->
      <!--        <img class="dollar-icon" src="@/assets/icon/green-dollar-icon.svg" />-->
      <!--        Available to offer-->
      <!--      </div>-->
    </div>
    <img class="artwork-image" :src="nftData.nftImage" />
    <div class="artwork-name">
      {{ nftData.name || nftData.nftName }} (ID: {{ nftData.nftId }})
    </div>
    <!-- <div class="creator">
      <jazzicon
        :address="nftData.sellerAddress"
        :diameter="24"
        class="creator-image"
      />
      <div class="creator-name">
        {{ nftData.sellerAddress | blockchainAddress }}
      </div>
    </div> -->
    <div class="sell-method-wrapper">
      <div class="sell-method">
        Level:
        <span class="method">{{ getSpecificAttribute('level') + 1 }}</span>
      </div>
    </div>
    <div class="sell-method-wrapper">
      <div class="sell-method">
        Baseline:
        <span class="method">{{ getSpecificAttribute('baseline') }}</span>
      </div>
    </div>
    <div class="sell-method-wrapper">
      <div class="sell-method">
        Mentoring Count:
        <span class="method">{{ getSpecificAttribute('mentoringCount') }}</span>
      </div>
    </div>
    <div class="sell-method-wrapper">
      <div class="sell-method">
        Sell Method: <span class="method">{{ nftData.sellMethod }}</span>
      </div>
    </div>
    <div class="price-wrapper">
      {{ getPriceText() }}:
      <span class="price">
        {{ nftData.price | formatWeiAmount }}
        {{ nftData.currencyAddress | transformToCurrencyName }}
      </span>
    </div>
  </div>
</template>

<script>
// import LikeButton from "@/components/BaseComponents/LikeButton.vue";
import { scrollToTop } from '@/helpers/utils';
import { getNftTax } from '@/helpers/index';

export default {
  components: {
    // LikeButton,
  },
  props: {
    nftData: {
      type: Object,
      require: true,
      default: () => {
        return {
          nftContract: 'N/A',
          nftId: 'N/A',
          nftImage: 'https://static.nft.bunicorn.exchange/bunicorn_logo2.png',
          nftName: 'N/A',
          sellMethod: 'N/A',
          price: 0,
          sellerAddress: 'N/A',
          currencyAddress: ''
        };
      }
    }
  },
  data() {
    return {
      artwork: {}
    };
  },
  mounted() {
    this.artwork = {
      isOfferable: true,
      isLiked: false,
      artworkURL: '/example-images/artwork-preview.png',
      artworkName: 'The Flight Girl',
      creatorURL: '/example-images/artwork-creater-avatar.png',
      creatorName: 'Guy Hawkins',
      sellMethod: 'Fixed Price',
      price: 500
    };
  },
  methods: {
    getNftTax,
    getSpecificAttribute(attributeName) {
      if (!this.nftData && !this.nftData.attributes) return 'N/A';
      const filteredList = this.nftData.nftAttributes.filter(
        attribute => attribute.trait_type === attributeName
      );
      if (!filteredList || filteredList.length <= 0) return 'N/A';
      return filteredList[0].value;
    },
    getPriceText() {
      switch (this.artwork.sellMethod) {
        case 'Fixed Price':
          return 'Price';
        case 'Auction':
          return 'Top Bid';
        case 'Dutch Auction':
          return 'Current Price';
        default:
          return 'Price';
      }
    },
    handleLike() {
      this.artwork.isLiked = !this.artwork.isLiked;
    },
    goToDetail() {
      this.$router.push({
        name: 'asset-detail',
        params: {
          nftContract: this.nftData.nftContract,
          nftId: this.nftData.nftId
        }
      });
      scrollToTop();
    }
  }
};
</script>

<style lang="scss" scoped>
.artwork-card {
  min-width: 258px;
  width: 258px;
  background: #ffffff;
  border: 1px solid #f3f5fa;
  box-sizing: border-box;
  border-radius: 10px;
  padding: 8px 14px 16px;
  font-family: Inter;
  font-size: 14px;
  margin: 0 8px;
  color: #203a54;
  font-feature-settings: 'salt' on, 'liga' off;
  cursor: pointer;
  &:hover {
    box-shadow: rgb(0 0 0 / 10%) 0px 0px 20px;
    opacity: 0.95;
    // box-shadow: 0px 0px 4px #c8ecfb, 0px 0px 8px #127ef1, 0px 0px 12px #1166cf,
    //   0px 0px 16px #1255b1, 0px 0px 20px #114392, inset 0px 0px 4px #c8ecfb;
    // transform: scale(1.01);
  }
  .header {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    .offer-avaiable {
      display: inherit;
      align-items: inherit;
      font-size: 12px;
      color: #36b37e;
      .dollar-icon {
        margin-right: 6px;
      }
    }
  }
  .artwork-image {
    margin-top: 6px;
    width: 220px;
    height: auto;
    border-radius: 10px;
    &:hover {
      cursor: pointer;
    }
  }
  .artwork-name {
    margin-top: 12px;
    font-size: 16px;
    font-weight: bold;
  }
  .creator {
    margin-top: 6px;
    display: flex;
    align-items: center;
    .creator-image {
      width: 24px;
      height: 24px;
    }
    .creator-name {
      margin-left: 10px;
    }
  }
  .sell-method-wrapper {
    margin-top: 12px;
    color: #828c9f;
    display: flex;
    justify-content: space-between;
    .sell-method {
      .method {
        color: #203a54;
        font-weight: 500;
      }
    }
  }
  .price-wrapper {
    color: #828c9f;
    margin-top: 6px;
    .price {
      font-weight: 500;
      color: #6f80f6;
    }
  }
}
</style>
